export default __webpack_public_path__ + "static/media/full-hd-high.c26ce26e.webm";